export const SUMMARY_ID = 1;
export const SUMMARY_TITLE = 'Summary';
